<!-- Page Title -->
<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content text-white">
                    <h2>Patenschaft</h2>
                    <ul class="text-gray-200">
                        <li><a routerLink="/" class="hover:underline">Home</a></li>
                        <li>Patenschaft</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Patenschaft Content -->
<section class="py-20 bg-white">
    <div class="container mx-auto px-4 max-w-5xl">
        <!-- Intro -->
        <div class="text-center mb-12">
            <h2 class="text-3xl font-bold text-gray-800 mb-4">Was ist eine Patenschaft?</h2>
            <p class="text-gray-600 text-lg">
                Eine Patenschaft ist eine langfristige, herzliche Verbindung zwischen einem Paten oder einer Patin
                und einem Kind in Togo. Sie ermöglichen Bildung, Ernährung und Hoffnung – Monat für Monat.
            </p>
        </div>

        <!-- Steps -->
        <div class="grid md:grid-cols-2 gap-8 mb-16">
            <div>
                <h3 class="text-2xl font-semibold text-green-700 mb-4">Wie funktioniert eine Patenschaft?</h3>
                <ol class="list-decimal list-inside space-y-2 text-gray-700">
                    <li><strong>Anmeldung:</strong> Sie wählen ein Kind aus und registrieren sich als Patin/Pate.</li>
                    <li><strong>Monatliche Unterstützung:</strong> Mit Ihrem Beitrag ermöglichen Sie Bildung und Ernährung.</li>
                    <li><strong>Kommunikation:</strong> Sie erhalten Briefe und Bilder, und können selbst schreiben oder schenken.</li>
                    <li><strong>Besuch:</strong> Treffen Sie Ihr Patenkind persönlich in Togo – unvergesslich!</li>
                </ol>
            </div>
        </div>

        <!-- Vorteile -->
        <div class="mb-16">
            <h3 class="text-2xl font-semibold text-green-700 mb-4">Vorteile einer Patenschaft</h3>
            <ul class="list-disc list-inside text-gray-700 space-y-2">
                <li><strong>Hilfe für ein Kind:</strong> Ihre Unterstützung verändert Leben.</li>
                <li><strong>Persönliche Beziehung:</strong> Sie schaffen Verbindung und Vertrauen.</li>
                <li><strong>Kultureller Austausch:</strong> Entdecken Sie die Vielfalt Togos.</li>
                <li><strong>Sinnvolle Investition:</strong> Sie fördern Bildung und Lebensperspektiven.</li>
            </ul>
        </div>

        <!-- Beitrag -->
        <div class="bg-green-100 rounded-xl p-6 text-center">
            <h3 class="text-2xl font-bold text-green-800 mb-2">Was kostet eine Patenschaft?</h3>
            <p class="text-lg text-gray-800">Mit nur <strong>20 € im Monat</strong> unterstützen Sie ein Kind und seine Familie nachhaltig.</p>
            <a routerLink="/kontakt" class="default-btn">
                Jetzt Pate werden
            </a>
        </div>

        <div class="row">
            <div   *ngFor="let _, index as i of dummyArray" class="col-xl-3 col-lg-4 col-md-6 mb-4">
                <div class="single-team text-center">
                    <div class="image">
                        <img src="assets/img/child/{{i+1}}.png" alt="{{i+1}}" class="img-fluid rounded">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<app-subscribe></app-subscribe>
